import * as fabric from 'office-ui-fabric-react';
import React, { FC, useState } from 'react';
import { KendoLoading } from '../../../components';
import { ILocationItem } from '../../../components/custom/LocationTree';
import { locationType } from '../../../enums';
import { CustomDropList } from './CustomDropList';

interface IProps {
    locations: ILocationItem[] | null;
}

const WorkplaceSelect: FC<IProps> = props => {
    const [department, setDepartment] = useState<ILocationItem | null>(null);

    const returnDepartments = () => props.locations!.filter(x => x.locationType === locationType.Department);

    const returnWorkplaces = () => {
        var mergedWorkplaces: ILocationItem[] = [];
        if (department) {
            var firstLevelChilds = props.locations?.filter(x => x.partOfLocationId == department.id);
            var lastLevelChilds = props.locations?.filter(x => x.locationType === locationType.Cabinet);

            if (firstLevelChilds && lastLevelChilds) {
                firstLevelChilds.map(x => {
                    mergedWorkplaces.push(x);

                    lastLevelChilds!
                        .filter(y => y.partOfLocationId === x.id)
                        .map(z => {
                            z.name = `${x.name} -> ${z.name}`;
                            mergedWorkplaces.push(z);
                        });
                });
            }
        }
        return mergedWorkplaces;
    };

    return (
        <fabric.Stack>
            {!props.locations && <KendoLoading />}
            {props.locations && !localStorage.getItem('locationId') && (
                <fabric.Stack.Item styles={{ root: { maxWidth: '300px' } }} align="center">
                    <fabric.Label>Skyrius</fabric.Label>
                    <CustomDropList items={returnDepartments()} selectItem={setDepartment} placeholder="Pasirinkite skyrių" />

                    {department && (
                        <div>
                            <fabric.Label>Darbo vieta</fabric.Label>
                            <CustomDropList
                                items={returnWorkplaces()}
                                selectItem={(location: ILocationItem) => {
                                    localStorage.setItem('locationId', location.id.toString());
                                    window.location.reload();
                                }}
                                placeholder="Pasirinkite darbo vietą"
                            />
                        </div>
                    )}
                </fabric.Stack.Item>
            )}
        </fabric.Stack>
    );
};

export default WorkplaceSelect;
